import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="map"
        path="/map-old"
        component={Page} />
];

export default Routes;